const ns = '[Street] ';

export const ADD_LANE = `${ns}add a lane`;
export const UPDATE_AXIS_RAD = `${ns}update axis horizontal radian`;
export const STRIPE_CLICKED = `${ns}stripe clicked`;
